import { createGlobalStyle } from 'styled-components';

export const ResetStyle = createGlobalStyle`
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        /* vertical-align: baseline; */
    }

    article, aside, details, figcaption, figure, 
    footer, header, hgroup, menu, nav, section {
        display: block
    }

    * {
        box-sizing: border-box;
    }

    body {
        font-size: 13px;
        color: #353535;
        font-weight: 400;
        font-family: "Microsoft Yahei","Helvetica Neue",Helvetica,Arial,sans-serif;
    }

    ol, ul {
        list-style: none
    }

    blockquote, q {
        quotes: none
    }

    q:before,
    q:after,
    blockquote:before,
    blockquote:after {
        content: ””;
    }

    table {
        border-spacing: 0;
        border-collapse: collapse;
    }

    a{
        color: #1890ff;
        text-decoration: none;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        -webkit-transition: color .3s;
        transition: color .3s;
    }

    ::-webkit-scrollbar {
        width: 8px;
        height: 10px;
    }
    
    ::-webkit-scrollbar-thumb{
        border-radius: 13px;
        background-color: #c2c2c2;
        background-clip: padding-box;
        min-height: 28px;
    }

    ::-webkit-scrollbar-track-piece{
        background-color: #eef0f2;
    }
`;
